var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"woot-table sla-reports-table"},[_c('ve-table',{attrs:{"fixed-header":true,"scroll-width":"60rem","columns":_vm.columns,"table-data":_vm.items,"border-around":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }